import { render, staticRenderFns } from "./PointSelector.vue?vue&type=template&id=ed4c5bcc&scoped=true"
import script from "./PointSelector.vue?vue&type=script&lang=ts"
export * from "./PointSelector.vue?vue&type=script&lang=ts"
import style0 from "./PointSelector.vue?vue&type=style&index=0&id=ed4c5bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4c5bcc",
  null
  
)

export default component.exports